import React from "react";
import "./closeIcon.css";
function CloseIcon() {
  return (
    <div>
      <div className="close"></div>
    </div>
  );
}

export default CloseIcon;